import React from "react";
import ImageComp from "../../../Assets/group1.png";
import {
  Container,
  FlexWrapper,
  Text3,
  Text4,
  Text5,
  Text6,
} from "../../Common/index";
import { ImageComponent } from "./style";
const WhoIsComponent = ({ heading, data }) => {
  return (
    <>
      <Container padding={"40px 0px "}>
        <FlexWrapper direction={"column"} margin={"40px auto"}>
          <Text3 color={"white"} weight={"bold"} fontFamily={"Inter"}>
            Who is esribelo a perfect fit for?
          </Text3>
          <FlexWrapper
            gap={"50px"}
            justify={"center"}
            margin={"40px auto"}
            width={"100%"}
          >
            <FlexWrapper
              direction={"column"}
              align={"center"}
              width={"25%"}
              mobileWidth={"100%"}
            >
              <ImageComponent src={ImageComp} />
              <Text5 color={"white"} weight={700} margin={"8px auto"}>
                Entrepreneurs
              </Text5>
              <Text6 color={"white"} align={"left"} weight={600}>
                Crank out high-quality content fast so you can grow your
                audience.
              </Text6>
            </FlexWrapper>

            <FlexWrapper
              direction={"column"}
              align={"center"}
              width={"25%"}
              mobileWidth={"100%"}
            >
              <ImageComponent src={ImageComp} />

              <Text5 color={"white"} weight={700} margin={"8px auto"}>
                Marketers
              </Text5>
              <Text6 color={"white"} align={"left"} weight={600}>
                Boost conversions on your ads, social, website, and emails.
              </Text6>
            </FlexWrapper>

            <FlexWrapper
              direction={"column"}
              align={"center"}
              width={"25%"}
              mobileWidth={"100%"}
            >
              <ImageComponent src={ImageComp} />

              <Text5 color={"white"} weight={700} margin={"8px auto"}>
                Agencies
              </Text5>
              <Text6 color={"white"} align={"left"} weight={600}>
                Crank out high-quality content fast so you can grow your
                audience.
              </Text6>
            </FlexWrapper>
          </FlexWrapper>
        </FlexWrapper>
      </Container>
    </>
  );
};

export default WhoIsComponent;
